// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".banner[data-v-76d624f1] {\n  width: 100%;\n  overflow: hidden;\n  list-style: none;\n  margin-bottom: 10px;\n}\n.banner .banner-item[data-v-76d624f1] {\n  display: block;\n  margin: auto;\n  width: 100%;\n  height: calc(( 170 / 750 ) * 100vw);\n}\n", ""]);
// Exports
module.exports = exports;
